import React from "react";
import Dashboard from "../../assets/img/Dashboard.png"
import ncentiva from "../../assets/img/ncentiva.png"
import { useHistory, useLocation } from 'react-router';
import dashImg from "../../assets/img/background.png"
const LoginLeft = (hideCursor) => {
  
  const cursorShow = hideCursor.hideCursor
  const history = useHistory()
  const redirectTohome = () =>{
  history.replace("/purchaser-auth/login")
  }
  return (
    <div className="authLeft  d-flex  position-relative align-items-center justify-content-center border-end h-100" style={{backgroundColor:"#E8EDFB"}}>
      <div className="card h-100 border-0 " style={{}}>
        <div className="card-header px-5  pt-4" style={{ cursor: cursorShow === true ? "pointer" : "default" }}>
          <img src="https://ncentiva-development.s3.eu-west-1.amazonaws.com/ncentiva_new_lowquality_logo.png" style={{width:"200px"}} alt="" onClick={()=> cursorShow === true ? redirectTohome() : null}/>
        </div>
        <div className="card-body ps-5 pt-4">
          <h3>Welcome to <br /><span>Ncentiva Purchasers Platform</span> </h3>
          {/* <p>
          Ncentiva provides a unique payout platform to disburse funds to your end customers.
          </p> */}
         
        </div>
        <div className="ms-5" style={{paddingTop:"71px"}}>
          <img src={dashImg} />
        </div>
        {/* <div className="card-footer pt-4 text-end pe-0 pb-0">
          <img src={Dashboard} alt="" />
        </div> */}
      </div>
    </div>
  );
};

export default LoginLeft;
